/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlASMEntityResponse
 */
export interface ControlASMEntityResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlASMEntityResponse
     */
    asm_entity_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlASMEntityResponse
     */
    favorite?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlASMEntityResponse
     */
    main?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlASMEntityResponse
     */
    original_main?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlASMEntityResponse
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof ControlASMEntityResponse
     */
    updated: string;
}

/**
 * Check if a given object implements the ControlASMEntityResponse interface.
 */
export function instanceOfControlASMEntityResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asm_entity_id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;

    return isInstance;
}

export function ControlASMEntityResponseFromJSON(json: any): ControlASMEntityResponse {
    return ControlASMEntityResponseFromJSONTyped(json, false);
}

export function ControlASMEntityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlASMEntityResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asm_entity_id': json['asm_entity_id'],
        'favorite': !exists(json, 'favorite') ? undefined : json['favorite'],
        'main': !exists(json, 'main') ? undefined : json['main'],
        'original_main': !exists(json, 'original_main') ? undefined : json['original_main'],
        'created': json['created'],
        'updated': json['updated'],
    };
}

export function ControlASMEntityResponseToJSON(value?: ControlASMEntityResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asm_entity_id': value.asm_entity_id,
        'favorite': value.favorite,
        'main': value.main,
        'original_main': value.original_main,
        'created': value.created,
        'updated': value.updated,
    };
}

